import type { FC } from 'react'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'

export const Unauthorized: FC = () => {
  return (
    <Container data-testid="unauthorized" maxWidth="sm" sx={{ pt: '50px' }}>
      <Card sx={{ p: '20px' }}>
        <CardContent>
          <Typography variant="h2" sx={{ ml: '10px' }}>
            Niet toegestaan
          </Typography>
          <Typography
            sx={{
              p: '10px',
              marginBottom: '16px',
            }}
          >
            U heeft niet genoeg rechten om deze applicatie te bekijken
          </Typography>
        </CardContent>
      </Card>
    </Container>
  )
}
